<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="'builderScreen.generator.modalTitle' | translateTA"
  [nzWidth]="1000"
  [nzFooter]="null"
  (nzOnCancel)="close()"
  nzCentered
>
  <ng-container *nzModalContent>
    <!-- Steps -->
    <nz-steps [nzCurrent]="currentStep" style="margin-bottom: 24px;">
      <nz-step
        *ngFor="let step of steps"
        [nzTitle]="step.title"
        [nzIcon]="step.icon"
      ></nz-step>
    </nz-steps>

    <!-- Step 0: JSON Input -->
    <div *ngIf="currentStep === 0" class="step-container">
      <nz-alert
        nzType="info"
        nzShowIcon
        style="margin-bottom: 16px;"
      >
        <span nz-alert-description>
          <strong>💡 {{ 'builderScreen.generator.howItWorks' | translateTA }}</strong> Cole um JSON de exemplo e o sistema detectará automaticamente
          a estrutura, criando grade e formulário completos!
        </span>
      </nz-alert>

      <!-- Templates de Exemplo -->
      <div style="margin-bottom: 16px;">
        <span style="margin-right: 8px;"><strong>📋 {{ 'builderScreen.generator.samples' | translateTA }}</strong></span>
        <button nz-button nzSize="small" (click)="loadSampleJSON('customers')">
          Clientes
        </button>
        <button nz-button nzSize="small" (click)="loadSampleJSON('products')" style="margin-left: 8px;">
          Produtos
        </button>
        <button nz-button nzSize="small" (click)="loadSampleJSON('orders')" style="margin-left: 8px;">
          Pedidos
        </button>
      </div>

      <!-- Textarea JSON -->
      <nz-form-item>
        <nz-form-label>Cole seu JSON aqui:</nz-form-label>
        <nz-form-control [nzErrorTip]="jsonError">
          <textarea
            nz-input
            [(ngModel)]="jsonInput"
            [nzAutosize]="{ minRows: 15, maxRows: 20 }"
            placeholder='{ "data": { "products": [{ "id": 1, "name": "..." }] } }'
            style="font-family: monospace;"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-alert
        *ngIf="jsonError"
        nzType="error"
        [nzMessage]="jsonError"
        nzShowIcon
        style="margin-top: 8px;"
      ></nz-alert>
    </div>

    <!-- Step 1: Analysis -->
    <div *ngIf="currentStep === 1" class="step-container analysis-step">
      <!-- ⭐ Indicador de scroll quando há muitas entidades -->
      <nz-alert
        *ngIf="analysisResult && analysisResult.entities.length > 3"
        nzType="info"
        [nzMessage]="'builderScreen.generator.manyEntitiesTitle' | translateTA"
        [nzDescription]="'builderScreen.generator.manyEntitiesHint' | translateTA"
        nzShowIcon
        nzCloseable
        style="margin-bottom: 16px;"
      ></nz-alert>

      <nz-result
        nzStatus="success"
        [nzTitle]="'builderScreen.generator.analysisDone' | translateTA"
        [nzSubTitle]="'Detectamos ' + (analysisResult?.entities.length || 0) + ' entidade(s)'"
      >
        <div nz-result-extra class="analysis-content">
          <div *ngFor="let entity of analysisResult?.entities; let i = index" style="margin-bottom: 16px;">
            <nz-card [nzTitle]="'#' + (i + 1) + ' - ' + entity.name" nzSize="small">
              <nz-statistic-group>
                <nz-statistic
                  [nzValue]="entity.suggestedColumns.length"
                  [nzTitle]="'builderScreen.generator.gridColumns' | translateTA"
                  [nzPrefix]="gridIcon"
                ></nz-statistic>
                <nz-statistic
                  [nzValue]="entity.suggestedFormFields.length"
                  [nzTitle]="'builderScreen.generator.formFields' | translateTA"
                  [nzPrefix]="formIcon"
                ></nz-statistic>
              </nz-statistic-group>

              <ng-template #gridIcon><i nz-icon nzType="table" nzTheme="outline"></i></ng-template>
              <ng-template #formIcon><i nz-icon nzType="form" nzTheme="outline"></i></ng-template>
            </nz-card>
          </div>
        </div>
      </nz-result>
    </div>

    <!-- Step 2: Configuration -->
    <div *ngIf="currentStep === 2" class="step-container">
      <nz-alert
        nzType="info"
        nzShowIcon
        style="margin-bottom: 16px;"
      >
        <span nz-alert-description>
          Configure as opções da tela. Todas as opções podem ser alteradas depois no Builder.
        </span>
      </nz-alert>

      <nz-form nzLayout="vertical">
        <!-- ⭐ NOVO: Separação clara entre Master-Detail e Geração de Formulários -->
        
        <!-- Master-Detail (Edição de Registros) -->
        <nz-form-item>
          <nz-form-label>
            <strong>✏️ {{ 'builderScreen.generator.enableMasterDetail' | translateTA }}</strong>
          </nz-form-label>
          <nz-form-control>
            <label nz-checkbox [(ngModel)]="config.enableMasterDetail">
              Permitir edição de registros (clicar em linha ou botão "Editar" abre painel)
            </label>
            <nz-alert
              *ngIf="config.enableMasterDetail"
              nzType="info"
              nzShowIcon
              [nzMessage]="'builderScreen.generator.masterDetailHint' | translateTA"
              [nzDescription]="'builderScreen.generator.masterDetailHint2' | translateTA"
              style="margin-top: 8px;"
            ></nz-alert>
          </nz-form-control>
        </nz-form-item>

        <!-- Auto-gerar Formulários (INDEPENDENTE de Master-Detail) -->
        <nz-form-item>
          <nz-form-label>
            <strong>📝 {{ 'builderScreen.generator.autoForms' | translateTA }}</strong>
          </nz-form-label>
          <nz-form-control>
            <label nz-checkbox [(ngModel)]="config.autoGenerateForms">
              Criar painéis de formulário para cada grade (com todos os campos)
            </label>
            <nz-alert
              *ngIf="config.autoGenerateForms && config.enableMasterDetail"
              nzType="success"
              nzShowIcon
              [nzMessage]="'builderScreen.generator.autoFormsConnected' | translateTA"
              style="margin-top: 8px;"
            ></nz-alert>
            <nz-alert
              *ngIf="config.autoGenerateForms && !config.enableMasterDetail"
              nzType="warning"
              nzShowIcon
              [nzMessage]="'builderScreen.generator.autoFormsNotConnected' | translateTA"
              [nzDescription]="'builderScreen.generator.autoFormsConnectHint' | translateTA"
              style="margin-top: 8px;"
            ></nz-alert>
          </nz-form-control>
        </nz-form-item>

        <!-- CRUD -->
        <nz-form-item>
          <nz-form-label>
            <strong>{{ 'builderScreen.generator.crud' | translateTA }}</strong>
          </nz-form-label>
          <nz-form-control>
            <label nz-checkbox [(ngModel)]="config.enableCRUD">
              Habilitar botões de Novo, Editar, Salvar, Excluir
            </label>
          </nz-form-control>
        </nz-form-item>

        <!-- Pagination -->
        <nz-form-item>
          <nz-form-label>
            <strong>{{ 'builderScreen.generator.pagination' | translateTA }}</strong>
          </nz-form-label>
          <nz-form-control>
            <label nz-checkbox [(ngModel)]="config.enablePagination">
              Habilitar paginação na grade
            </label>
            <nz-input-number
              *ngIf="config.enablePagination"
              [(ngModel)]="config.pageSize"
              [nzMin]="5"
              [nzMax]="100"
              [nzStep]="5"
              style="width: 120px; margin-left: 16px;"
            ></nz-input-number>
            <span *ngIf="config.enablePagination" style="margin-left: 8px;">{{ 'builderScreen.generator.itemsPerPage' | translateTA }}</span>
          </nz-form-control>
        </nz-form-item>

        <!-- Filters and Sorting -->
        <nz-form-item>
          <nz-form-label>
            <strong>Recursos da Grade</strong>
          </nz-form-label>
          <nz-form-control>
            <div>
              <label nz-checkbox [(ngModel)]="config.enableFilters">Filtros</label>
              <label nz-checkbox [(ngModel)]="config.enableSorting" style="margin-left: 16px;">{{ 'builderScreen.generator.sorting' | translateTA }}</label>
            </div>
          </nz-form-control>
        </nz-form-item>
      </nz-form>
    </div>

    <!-- Step 3: Generation -->
    <div *ngIf="currentStep === 3" class="step-container">
      <nz-result
        nzStatus="info"
        [nzTitle]="'builderScreen.generator.readyTitle' | translateTA"
      >
        <div nz-result-content>
          <div style="text-align: left; max-width: 600px; margin: 0 auto;">
            <h4>📋 {{ 'builderScreen.generator.summary' | translateTA }}</h4>
            <ul>
              <li>{{ 'builderScreen.generator.summary.entities' | translateTA: { count: analysisResult?.entities.length } }}</li>
              <li>{{ 'builderScreen.generator.summary.tabs' | translateTA: { count: analysisResult?.suggestedLayout.tabs.length } }}</li>
              <li>{{ 'builderScreen.generator.summary.panels' | translateTA: { count: analysisResult?.suggestedLayout.panels.length } }}</li>
              <li *ngIf="config.enableMasterDetail">✏️ {{ 'builderScreen.generator.summary.masterDetailOn' | translateTA }}</li>
              <li *ngIf="config.autoGenerateForms">📝 {{ 'builderScreen.generator.summary.autoFormsOn' | translateTA: { count: analysisResult?.entities.length } }}</li>
              <li *ngIf="config.enableCRUD">✅ {{ 'builderScreen.generator.summary.crudOn' | translateTA }}</li>
              <li *ngIf="config.enablePagination">✅ {{ 'builderScreen.generator.summary.paginationOn' | translateTA: { size: config.pageSize } }}</li>
            </ul>
          </div>
        </div>
        <div nz-result-extra>
          <button nz-button nzType="primary" nzSize="large" (click)="generate()">
            <i nz-icon nzType="rocket" nzTheme="filled"></i>
            Gerar Tela Agora!
          </button>
        </div>
      </nz-result>
    </div>

    <!-- Navigation Buttons -->
    <div class="wizard-footer" style="margin-top: 24px; text-align: right; border-top: 1px solid #f0f0f0; padding-top: 16px;">
      <!-- Botão Voltar (aparece do step 1 ao 2) -->
      <button
        nz-button
        nzType="default"
        (click)="previous()"
        *ngIf="currentStep > 0 && currentStep < 3"
      >
        <i nz-icon nzType="left"></i>
        Voltar
      </button>
      
      <!-- Botão Próximo (aparece do step 0 ao 2) -->
      <button
        nz-button
        nzType="primary"
        (click)="next()"
        *ngIf="currentStep < 3"
        style="margin-left: 8px;"
      >
        Próximo
        <i nz-icon nzType="right"></i>
      </button>
      
      <!-- Botão Cancelar (sempre visível) -->
      <button
        nz-button
        nzType="default"
        (click)="close()"
        style="margin-left: 8px;"
      >
        Cancelar
      </button>
    </div>
  </ng-container>
</nz-modal>

